<template>
  <lb-dialog v-model="localAllAccessDownloadDialog" :loading="allAccessDownloadLoading"
    heading="All access data download" width="600">
    <template v-slot:body>
      <div>
        <div class="d-flex align-center">
          <v-spacer />
          <v-btn color="primary" @click="$emit('download-all-access')"><span>Generate latest</span></v-btn>
        </div>
        <div v-if="allAccessDownloadList.length === 0" class="title grey--text text--lighten-1 ma-4 text-center">No
          downloads</div>
        <div v-else>
          <div class="mb-2 font-weight-bold">Previous downloads</div>
          <div class="hoverable" v-for="(v,k) in allAccessDownloadList" :key="k">
            <div class="d-flex align-center px-2 py-1">
              <div>{{$nova.formatDateTime(v.created_at)}}</div>
              <v-spacer />
              <v-tooltip bottom content-class="tooltip-bottom" v-if="v.stage===1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mx-0 px-0" icon v-bind="attrs" v-on="on"
                    @click.stop="$emit('download-file', v._id)">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Download</span>
              </v-tooltip>
              <v-chip v-if="v.stage === 1" color="success" label><span>Ready</span></v-chip>
              <v-chip v-else-if="v.stage === 0 || v.stage === 4" color="info" label><span>Generating</span></v-chip>
              <v-chip v-else color="error" label><span>Error</span></v-chip>
            </div>
            <v-divider />
          </div>
        </div>
      </div>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'AllAccessDownloadDialog',
  props: {
    value: { type: Boolean, default: false },
    allAccessDownloadList: { type: Array, default: () => [] },
    allAccessDownloadLoading: { type: Boolean, default: false }
  },
  computed: {
    localAllAccessDownloadDialog: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    }
  }
}
</script>

<style scoped>
.hoverable:hover {
  background-color: #f5f5f5;
  cursor: default;
}
</style>